"use strict";
var binding_scope_1 = require("../bindings/binding_scope");
var binding_when_on_syntax_1 = require("./binding_when_on_syntax");
var BindingInSyntax = (function () {
    function BindingInSyntax(binding) {
        this._binding = binding;
    }
    BindingInSyntax.prototype.inSingletonScope = function () {
        this._binding.scope = binding_scope_1.default.Singleton;
        return new binding_when_on_syntax_1.default(this._binding);
    };
    BindingInSyntax.prototype.inTransientScope = function () {
        this._binding.scope = binding_scope_1.default.Transient;
        return new binding_when_on_syntax_1.default(this._binding);
    };
    return BindingInSyntax;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BindingInSyntax;



//////////////////
// WEBPACK FOOTER
// ./~/inversify/lib/syntax/binding_in_syntax.js
// module id = 28
// module chunks = 0